module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp23_8011.42d7f7aa.png";